/**
 *  1.axios配置  2.请求拦截器 3.接口报错统一处理
 */

// 引入模块
// import store from '@/store/index' //登录后将token存储在store 中因此需要引入
import qs from 'qs' // 使用qs 将数据格式转为表单提交，看后台需要什么类型的传参，非必须
import axios from 'axios'

// axios初始化：延迟时间，主路由地址,是否允许跨域
let instance = axios.create({
  baseURL: '/v1',//默认环境
  timeout: 10000,
});

// 设置拦截器
instance.interceptors.request.use(function (config) {
  console.log(12323)
    config.headers["Authorize"] = localStorage.getItem('vb-token')
    return config;
}, function (error) {
  console.log("拦截器---err")
  //请求错误时做些事
  return Promise.reject(error);
});
//响应拦截器
instance.interceptors.response.use(function (response) {

  
  //对响应数据做些事
  return response;
}, function (error) {
  //请求错误时做些事
  return Promise.reject(error);
});

// 是否销毁拦截器
// 1.给拦截器起个名称 var myInterceptors = instance.interceptors.requesst.use();
// 2.instance.interceptors.request.eject(myInterceptor);

// 请求成功的回调
function checkStatus(res) {
  //请求结束成功
  if (res.status === 200 || res.status === 304) {
    return res.data
  }
  return {
    code: 0,
    msg: res.data.msg || res.statusText,
    data: res.statusText
  }
}
// 请求失败的回调
function checkCode(res) {
//   if (res.code === 0) {
//     throw new Error(res.msg)
//   }
  return res
}
function handleNoFound(url, params, promiseInstance) {
  return new Promise(resolve => promiseInstance(url, params).then(res => resolve(res)).catch((res) => { resolve(res) }))
}
//模块化导出
export default {
  get(url, params) {
    if (!url) return;
    return instance({
      method: 'get',
      url: url,
      params,
      timeout: 30000
    }).then(checkStatus).then(checkCode)
  },
  post(url, data) {
    if (!url) return;
    return instance({
      method: 'post',
      url: url,
      data: qs.stringify(data),
      timeout: 30000
    }).then(checkStatus).then(checkCode)
  },
  postjson: (url, params) => handleNoFound(url, params, (url, data) => {
    if (!url) return;
    return instance({
      method: 'post',
      url: url,
      data: data,
      timeout: 30000
    }).then(checkStatus).then(checkCode)
  }),
  postFile(url, data) {
    if (!url) return;
    return instance({
      method: 'post',
      url: url,
      data
    }).then(checkStatus).then(checkCode)
  }
}